module.exports = __webpack_public_path__ + "static/media/banner-illustration.1ef64faa.svg";